export class Retailer {
  key: number;
  name: string;
  description: string;


  constructor(object: any = null) {
    if (object != null) {
      Object.assign(this, object);
    }
  }
}
